<template>
	<div>
		<el-card class="box-card" style="position: relative;">
			<div slot="header">
				<span class="top_title">账号信息</span>
			</div>
			<el-form ref="form" :model="form" label-width="80px">
				<el-form-item label="账号" v-if="userType==1">
					<el-input v-model="form.account" disabled></el-input>
				</el-form-item>
				<el-form-item label="所属公司">
					<el-input v-model="form.company" disabled></el-input>
				</el-form-item>
				<el-form-item label="级别">
					<el-input v-model="form.type" disabled></el-input>
				</el-form-item>
				<el-form-item label="手机号">
					<el-input v-model="form.phone" disabled></el-input>
				</el-form-item>
				<el-form-item label="姓名">
					<el-input maxlength="30" v-model="form.name"></el-input>
				</el-form-item>
				<el-form-item label="地址" v-if="userType==0">
					<el-input maxlength="80" v-model="form.address"></el-input>
				</el-form-item>
				<el-form-item label="客户状态" v-if="userType==0&&stateList.length>0">
					<el-select v-model="cstate" placeholder="请选择" multiple style="width: 300px">
						<el-option v-for="(item,index) in stateList" :key="index" :label="item" :value="item"></el-option>
					</el-select>
					<el-button type="primary" @click="stateSave">保存</el-button>
				</el-form-item>
				<el-form-item label="产品模式" v-if="userType==0">
					<el-select v-model="buyType" placeholder="请选择" style="width: 120px" @change="specChange">
						<el-option :label="$global.unit+'&'+$global.pack" value="0"></el-option>
						<el-option :label="$global.pack" value="1"></el-option>
						<el-option :label="$global.unit" value="2"></el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<el-form style="display:flex;justify-content:center;">
				<el-button type="primary" @click="save()" v-show="userType==0">保存</el-button>
				<el-button type="primary" icon="el-icon-edit" @click="passwordPanel=!passwordPanel">修改密码</el-button>
			</el-form>
			<el-button type="warning" class="exitbtn" @click="out">退出</el-button>
		</el-card>
		<el-dialog title="修改密码" :visible.sync="passwordPanel" width="60%">
			<Password ref="password" style="overflow: auto" @close="close" />
		</el-dialog>
	</div>
</template>

<script>
import Password from '@/views/my/password.vue';
	export default {
		components: {Password},
		data() {
			return {
				userType:0,
				buyType:"1",
				cstate:[],
				form: {
					account:'',
					roleNames:'',
					company:'',
					type:'',
					name: '',
					phone: '',
					address: ''
				},
				passwordPanel:false,
				stateList:[],
			};
		},
		created(){
			let _this = this;
			if(this.$global.userType==0){
				this.cstate = this.$global.customerState?this.$global.customerState.split(','):[];
				this.$api.homeGetEmpInfo().then((res)=>{
					if(res.data.code==1){
						let dd = res.data.data;
						let nowcmp = this.$global.cmpId.cmp;
						dd.company.forEach(e=>{
							if(e.id==nowcmp){
								_this.form.company = e.name;
							}
						})
						_this.userType = 0;
						_this.form.type = "职工";
						_this.form.name = dd.name;
						_this.form.phone = dd.phone;
						_this.form.address = dd.address;
					}
				})
				this.$api.getCustomerState({page:1,limit:-1}).then(res=>{
					this.stateList = [];
					let arr = res.data.data.customer_state;
					if(arr&&arr.length>0){
						arr.forEach(e=>{
							this.stateList.push(e.label);
						})
					}
				})
			}else if(this.$global.userType==1){
				this.userType = 1;
				this.$api.homeGetEmpInfo().then((res)=>{
					if(res.data.code==1){
						let dd = res.data.data;
						
						_this.form.account = dd.username;
						_this.form.company = dd.cmpName;
						_this.form.type = dd.rank;
						_this.form.name = dd.cname;
						_this.form.phone = dd.phone;
						_this.form.address = dd.address;
					}
				})
			}
			this.buyType = ""+this.$global.buyType;
		},
		methods: {
			stateSave(){
				let str = this.cstate.join(',');
				if(str!=this.$global.customerState){
					let obj = {
						customerMobileShow:str,
					}
					this.$api.setDataStorage({data:JSON.stringify(obj),share:0}).then(()=>{
						this.$notify({
							title: "客户状态",
							message: "修改成功",
							type: "success",
							duration: 1000,
						});
						this.$global.customerState = str;
					})
				}
			},
			specChange(e){
				this.$global.buyType = this.buyType;
				localStorage.setItem('ipad_buytype',this.buyType);
				this.$notify({
					title: "产品模式",
					message: "修改成功",
					type: "success",
					duration: 1000,
				});
			},
			close() {
				this.passwordPanel = !this.passwordPanel;
			},
			save(){
				if(!this.form.name){
					this.$common.error("名字不能为空");
					return;
				}
				
				if(this.userType==0){
					let obj = {
						name:this.form.name,
						address:this.form.address,
						phone:this.form.phone,
					}
					this.$api.editEmployee(obj).then(res=>{
						if(res.data.code==1){
							this.editSuccess();
						}
					})
				}else if(this.userType==1){
					let obj = {
						cname:this.form.name, 
					}
					this.$api.editLoginCustomer(obj).then(res=>{
						if(res.data.code==1){
							this.editSuccess();
						}
					})
				}
			},
			editSuccess(){
				this.$global.name = this.form.name;
				localStorage.setItem("name",this.form.name);
				this.$notify({
					title: "修改信息",
					message: "修改成功",
					type: "success",
					duration: 1000,
					onClose:()=>{
						this.$router.push("/product");
					}
				});
			},
			out() {
				this.$global.goodsSelect = {};
				this.$global.cid = 0;
				localStorage.removeItem('token');
				localStorage.removeItem('shopingcart');
				this.$router.push('/login?cmp='+this.$global.cmpId.cmp);
			},
		}
	};
</script>

<style lang='scss' scoped>
.exitbtn{
	position: absolute;
	top: 12px;
	right: 20px;
}
</style>
